import { render } from "./LandingPage.vue?vue&type=template&id=2e27ae9d"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__